module.exports = __webpack_public_path__ + "static/img/img-features-feature-3-list-m@2x.7a9100c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-3-list-m@2x.png
// module id = VOs8
// module chunks = 18